
import {tickStorage} from "@dashboard/contexts/tickStore";
import { apiFetch} from "apiClient";
import { apiFetch as fetch } from "apiClient";

export const getLastPrice   = (instrumentToken,tick) => {
    if (!tick || typeof tick !== 'object') {
        return 0; // Return 0 if tick is undefined or not an object
    }
    const quote = tick[instrumentToken]; // Access directly by key
    return quote ? quote.lastPrice : 0;
};

export const getLastClosePrice   = (instrumentToken,pfQuotes) => {
    if (!pfQuotes || typeof pfQuotes !== 'object') {
        return 0; // Return 0 if pfQuotes is undefined or not an object
    }
    const quote = pfQuotes[instrumentToken]; // Access directly by key
    return quote ? quote.ohlc.close : 0;
};

export const getQuote   = (instrumentToken,pfQuotes) => {
    if (!pfQuotes || typeof pfQuotes !== 'object') {
        return 0; // Return 0 if pfQuotes is undefined or not an object
    }
    const quote = pfQuotes[instrumentToken]; // Access directly by key
    return quote ? quote : 0;
};

export const fetchManualContractNoteNo = async (prefix) => {
    try {
        const qs  = new URLSearchParams({ prefix }).toString();
        const res = await fetch(`/api/portfolio/generateManualContractNoteNo?${qs}`);

// endpoint likely returns a plain string; handle both JSON or text safely
        let value;
        try {
            value = await res.json();
        } catch {
            value = await res.text();
        }

        if (value) {
            console.log("📌 Received manualContractNoteNo:", value);
            return value;
        }

        console.log("Invalid response from API.");
        return "";
    } catch (error) {
        console.log("Error in API call:", error);
        return "";
    }
};

export const deleteContractNote = async (contractNoteNo) => {
    if (!window.confirm(
        "Are you sure you want to delete this contract note? This action cannot be undone."
    )) {
        return { success: false, cancelled: true };
    }

    try {
        const res = await fetch(
            `/api/portfolio/deleteContractNote?contractNoteNo=${encodeURIComponent(contractNoteNo)}`,
            {
                method: "DELETE",
                credentials: "include" // IMPORTANT if you use session auth
            }
        );

        const contentType = res.headers.get("content-type") || "";
        const data = contentType.includes("application/json")
            ? await res.json()
            : await res.text();

        if (!res.ok) {
            const message =
                typeof data === "string" && data
                    ? data
                    : data?.message || data?.error || `Delete failed (HTTP ${res.status})`;
            alert(message);
            return { success: false, error: message, status: res.status };
        }

        alert("Deleted successfully.");
        return { success: true, data };

    } catch (err) {
        console.error("Error deleting:", err);
        alert("Failed to delete. Please try again.");
        return { success: false, error: err?.message || String(err) };
    }
};

export const saveContractNote = async (newContractNote, isDisplayClick) => {
    console.log("newContractNote:",newContractNote);
    try {
        const path = isDisplayClick
            ? "/api/portfolio/updateContractNote"
            : "/api/portfolio/saveContractNote";

        const res = await fetch(path, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(newContractNote),
        });

// Support text or JSON responses
        // Safely parse body only once
        let data;
        const contentType = res.headers.get("content-type") || "";

        if (!res.ok) {
            // Backend error case
            if (contentType.includes("application/json")) {
                const body = await res.json();
                const message = body?.message || body?.error || JSON.stringify(body);
                return { success: false, error: message };
            } else {
                const text = await res.text();
                return { success: false, error: text || "Unknown backend error" };
            }
        }

// Success case
        if (contentType.includes("application/json")) {
            data = await res.json();
        } else {
            data = await res.text();
        }

        return { success: true, data };

    } catch (saveError) {
        console.error("Error saving contract note:", saveError);
        alert("Failed to save contract note.");
        return { success: false, error: saveError.message }; // ✅ Return failure & error message
    }
};

export const calculateLatestPFValues = (stock, pfQuotes) => {
    const instrumentToken = stock.instrumentEntity.instrumentToken;
    const tick = tickStorage.latest?.[instrumentToken] ?? null;

    const lastPrice = tick?.lastTradedPrice ?? getLastPrice(instrumentToken, pfQuotes);
    const closePrice = tick?.closePrice ?? getLastClosePrice(instrumentToken, pfQuotes);

    if (lastPrice === undefined || closePrice === undefined) {
        console.warn(`Missing price for ${stock.symbol}`);
        return null;
    }

    let priceDiffToday=lastPrice - closePrice;
    const todayGain = priceDiffToday * stock.netQuantity;
    const todayGainPerc = closePrice ? ((priceDiffToday / closePrice) * 100).toFixed(2) : 0.00;
    const overallGain = (lastPrice * stock.netQuantity) - stock.amountInvested;
    const currentValue = lastPrice * stock.netQuantity;

    return {
        lastPrice,
        closePrice,
        todayGain,
        todayGainPerc,
        overallGain,
        currentValue
    };
};

export async function deleteDownloadedContractNote(id) {
    const res = await fetch(`/api/portfolio/deleteDownloadedContractNote/${id}`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" }
    });

    if (!res.ok) {
        const errorText = await res.text();
        throw new Error(errorText || "Failed to delete file record.");
    }

    return true;
}



